<template>
  <div class="wrap-statistic">
    <head-view :option="title" :subtitleOpt="subtitleOpt"></head-view>
    <div class="statistics-content">
      <!-- <div class="content__chart" v-if="existUserChart">
        <div id="myChart" class="chart" ref="apexChart"></div>
      </div> -->
      <div class="dp-stat">
        <!-- <date-picker v-model="dateSelect" class="data-picker-custom" range lang="es" format="DD MMM YYYY" confirm @confirm="changeDate" placeholder="Todas la fechas"></date-picker> -->
        <template>
          <div>
            <div class="datepicker-trigger">
              <input
                class="input-date"
                type="text"
                id="datepicker-trigger"
                placeholder="Select dates"
                :value="formatDates(dateOne, dateTwo)">
                  <AirbnbStyleDatepicker
                    :trigger-element-id="'datepicker-trigger'"
                    :mode="'range'"
                    :fullscreen-mobile="true"
                    :date-one="dateOne"
                    :date-two="dateTwo"
                    @date-one-selected="val => { dateOne = val }"
                    @date-two-selected="val => { dateTwo = val }"
                    @apply="changeDate"/>
            </div>
          </div>
        </template>
      </div>
      <div class="content__chart" v-if="existUserChart">
        <div id="myChart" class="chart" ref="userHour"></div>
      </div>
      <b-loading v-else :is-full-page="false" :active.sync="$store.state.isLoader" :can-cancel="false"></b-loading>
      <div class="wrap-download">
        <button class="download-button" @click="downloadCSV">Descargar CSV</button>
      </div>
      <div class="content__table">
        <!-- <table-data :headers="headers" :width="width" source="statisticCP" :data="dataTable"></table-data> -->
        <div class="wrapper-select wrapper-select--footer" v-if="currentReporterList">
					<div class="table-section">
						<b-table
						class="table-history"
            :data="currentReporterList ? currentReporterList : []"
            :loading="isLoading">
							<template slot-scope="props">
									<b-table-column field="date" label="Fecha" width="300" :custom-sort="dateSort">
											{{ props.row.date }}
									</b-table-column>
                  <b-table-column field="initdate" label="Hora de inicio" width="300">
											{{ localDateTime(props.row.initDate) }}
									</b-table-column>
                  <b-table-column field="enddate" label="Hora de fin" width="300">
											{{ localDateTime(props.row.endDate) }}
									</b-table-column>
                  <b-table-column field="diffTime" label="Duración" width="300">
											{{ props.row.diffTime }}
									</b-table-column>
									<b-table-column field="reportedtasks" label="Tareas Reportadas" width="300" centered numeric>
											<span class="task-rep">{{ props.row.reportedtasks }}</span>
									</b-table-column>
									<!-- <b-table-column field="pending" label="Tareas Pendientes" numeric>
											{{ props.row.taskPending }}
									</b-table-column>
                  <b-table-column field="time" label="Duración" width="200" numeric>
											{{ props.row.time }}
									</b-table-column> -->
							</template>

							<template slot="empty">
									<section class="section">
											<div class="content has-text-grey has-text-centered">
													<p>
															<b-icon
																	icon="emoticon-sad"
																	size="is-large">
															</b-icon>
													</p>
													<p>No hay datos en el rango de fechas seleccionadas.</p>
											</div>
									</section>
							</template>
        		</b-table>
					</div>
				</div>
      </div>

      

    </div>
  </div>
</template>

<script>
import headView from "../Componentes/headView";
import { mapState } from "vuex";
import ApexCharts from "apexcharts";
import format from 'date-fns/format'
export default {
  components: {
    headView
  },
  data() {
    return {
      title: {
        headText: "Estadísticas",
        subtitle: "Reportadores Historic"
      },
      subtitleOpt: false,
      dateSelect: "",
      arr: [],
      isLoading: false,
      dateFormat: 'D MMM',
      dateOne: '',
      dateTwo: '',
      user: null
    };
  },
  computed: {
    ...mapState(["currentReporterChart", "currentReporterList"]),
    // dataTable() {
    //   let obj = {
    //     date: "5/09/2018",
    //     taskDone: 28,
    //     taskPending: 72,
    //     time: 5
    //   };
    //   let obj2 = {
    //     date: "5/09/2018",
    //     taskDone: 28,
    //     taskPending: 72,
    //     time: 5
    //   };
    //   let obj3 = {
    //     date: "5/09/2018",
    //     taskDone: 28,
    //     taskPending: 72,
    //     time: 5
    //   };
    //   this.arr.push(obj);
    //   this.arr.push(obj2);
    //   this.arr.push(obj3);
    //   return this.arr;
    // },
    existUserChart() {
      console.log(this.currentReporterChart);
      
      if (this.currentReporterChart) {
        this.$nextTick(() => {
          this.myChart = new ApexCharts(
            this.$refs.userHour,
            this.currentReporterChart
          );
          this.myChart.render();
        });
        return true;
      }
      return false;
    },
    isLoadingComp(){
      if(this.currentReporterList){
        this.isLoading = false
      }
      return true
    }
  },
  created() {
    // this.$store.commit('drawReporterHistoric')
    this.$store.dispatch("GETREPORTERHISTORIC", {
      user: this.$route.params.id
    }).then(res => {
      this.user = res.user
    });
  },
  beforeCreate() {
    this.$store.commit("setColorChildren", "statisticsReporters");
  },
  beforeDestroy() {
    this.$store.commit("resetColorChildren", "statisticsReporters");
  },
  methods: {
    changeDate() {
      this.$store.dispatch("GETREPORTERHISTORIC", {
        user: this.$route.params.id,
        startDate: new Date(new Date(this.dateOne.replace("-", ".")).setHours(0, 0, 0, 0)).toISOString(),
        endDate: new Date(new Date(this.dateTwo.replace("-", ".")).setHours(23, 0, 0, 0)).toISOString()
      });
    },
    localDateTime(date){
      var obj = new Date(date)
      return obj.toLocaleTimeString()
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = ''
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat)
      }
      if (dateTwo) {
        formattedDates += ' - ' + format(dateTwo, this.dateFormat)
      }
      return formattedDates
    },
    dateSort(val1, val2, isAcc ){
      // console.log(val1, val2, isAcc);
      var date2 = val2.date.split('-')
      var date1 = val1.date.split('-')
      var aux = date2[0]
      date2[0] = date2[1]
      date2[1] = aux
      aux = date1[0]
      date1[0] = date1[1]
      date1[1] = aux
      if(isAcc){
        // console.log(new Date(date2.join('.')) , new Date(date1.join('.')));
        
        return new Date(date2.join('.')) - new Date(date1.join('.'))
      }else{
        return new Date(date1.join('.')) - new Date(date2.join('.'))
      }
    },
    downloadCSV: function() {
      console.log(this.currentReporterList);
      const dataArray = this.currentReporterList.map(row => {
        return {
          date: row.date,
          initDate: row.initDate,
          endDate: row.endDate,
          duration: row.duration,
          repotedtasks: row.reportedtasks
        }
      }).map(row => {
          return Object.values(row);
        });
      dataArray.unshift([
        "Fecha",
        "Hora de Inicio",
        "Hora de Fin",
        "Duración",
        "Tareas Reportadas"
      ]);
      let csvContent =
        "data:text/csv;charset=utf-8," +
        dataArray.map(e => e.join(",")).join("\n");
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `reporte_${this.user.firstName}_${this.user.lastName}.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    }
  }
};
</script>
<style lang="scss">
.asd__day{
  padding: 0.3em !important;
}
</style>
<style lang="scss" scoped>
.wrap-statistic {
  height: 100%;
}
.statistics-content {
  margin-top: 4em;
  padding: 2em;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  .dp-stat {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 0 5rem;
  }
}
.chart {
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.button-edit {
  border: thin solid #e6e4e6;
  padding: 1rem;
  color: #000000;
  font-weight: bold;
  margin: 25px;
}
.task-rep{
  font-weight: bold;
}
.input-date{
  padding: 0.5rem 1rem;
  font-size: 0.8rem;
  border: thin solid #00a699;
}
.wrap-download {
  text-align: end;
}
.download-button {
  background-color: #00a699;
  color: #ffffff;
  padding: 8px 32px;
  border: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/statisticUserHistoric.vue